import Swiper from 'swiper/bundle';
import { updateOpacity } from './utils';

export default function initSwiperArgs() {
    const swiperArgsContainer = document.querySelector(".swiper-args");

    if (swiperArgsContainer) {
        const swiperArgs = new Swiper(".swiper-args", {
            slidesPerView: 2,
            spaceBetween: 10,
            loop: false,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                },
                1400: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
            },
            navigation: {
                nextEl: ".block-args .swiper-next",
                prevEl: ".block-args .swiper-prev",
            },
            on: {
                slideChange: () => updateOpacity(swiperArgs),
                resize: () => updateOpacity(swiperArgs)
            }
        });

        updateOpacity(swiperArgs);
    }
}
